import React from 'react'

export const BootstrapLoader = () => {
  return (
    <div class="spinner-border text-success" role="status">
        <span class="sr-only"></span>
    </div>
  )
}
